import { Route } from "react-router-dom";
import { User } from "./components/User";
import { DepositUnderApproval } from "../deposit/components/DepositUnderApproval";
import { WithdrawUnderApproval } from "../withdraw/components/WithdrawUnderApproval";

export default function UserRoutes() {
  return (
    <>
      <Route path="profile" element={<User activeTab="profile" />} />
      <Route path="deposit" element={<User activeTab="deposit" />} />
      <Route path="withdrawal" element={<User activeTab="withdrawal" />} />
      <Route path="wallethistory" element={<User activeTab="wallethistory" />} />
      <Route path="transactions" element={<User activeTab="transactions" />} />
      <Route path="bonus" element={<User activeTab="bonus" />} />
      <Route path="inbox" element={<User activeTab="inbox" />} />
      <Route path="verification" element={<User activeTab="verification" />} />
      <Route path="responsible-gaming" element={<User activeTab="responsible-gaming" />} />

      <Route
        path="/deposit-under-approval"
        element={<DepositUnderApproval />}
      />
      <Route
        path="/withdraw-under-process"
        element={<WithdrawUnderApproval />}
      />

      <Route
        path="deposithistory"
        element={<User activeTab="transactions" transactionTab="deposit" />}
      />
      <Route
        path="withdrawhistory"
        element={<User activeTab="transactions" transactionTab="withdraw" />}
      />
      <Route
        path="exchangehistory"
        element={<User activeTab="transactions" transactionTab="exchange" />}
      />
      <Route
        path="sportshistory"
        element={<User activeTab="transactions" transactionTab="sports" />}
      />
      <Route
        path="casinohistory"
        element={<User activeTab="transactions" transactionTab="casino" />}
      />
      <Route
        path="balanceAdjustment"
        element={
          <User activeTab="transactions" transactionTab="adjustments" />
        }
      />
    </>
  );
}
